export default __webpack_public_path__ + "static/media/star.583da226.svg";